<div class="modal fade auth-modal" id="image-upload" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body" *ngIf="!showCamera">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title" *ngIf="!cropView && mode=='profile pic'">Upload profile picture</span>
                    <span class="modal-title" *ngIf="cropView && mode=='profile pic'">Crop profile picture</span>
                    <span class="modal-title" *ngIf="!cropView && mode=='blog pic'">Upload Blog Image</span>
                    <span class="modal-title" *ngIf="cropView && mode=='blog pic'">Crop Blog picture</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal" (click)="clear()"></i>
                </div>
                <div class="horizontal-line mb-3"></div>
                <div class="image-cropper mx-3">
                    <input #fileupload type="file" (change)="fileChangeEvent($event)" />
                    <span>Click Here to Upload</span>
                    <image-cropper class="original-image" [ngStyle]="{'opacity' : croppedImage.length ? '1':'0'}"
                        [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [imageBase64]="cameraImage"
                        [aspectRatio]="aspectRatio" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [autoCrop]="true"
                        outputType="base64"></image-cropper>
                </div>
                <div class="d-flex flex-row justify-content-end mt-3 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal"
                        (click)="clear();clearBlogImage();">Cancel</button>
                    <button class="btn btn-theme" (click)="onApply()">Apply</button>
                </div>
            </div>
            <div class="modal-body" *ngIf="showCamera">
                <div class="d-flex flex-row justify-content-between mt-3 mb-2 px-3">
                    <span class="modal-title">Capture profile picture</span>
                    <i class="fas fa-times modal-close" data-dismiss="modal" (click)="clear()"></i>
                </div>
                <div class="horizontal-line mb-3"></div>
                <div *ngIf="isCameraExist">
                    <div class="text-center">
                        <webcam class="camera-view" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                            [switchCamera]="nextWebcamObservable"></webcam>
                    </div>
                    <div *ngIf="errors.length > 0">
                        <h4>Something went wrong !</h4>
                    </div>
                </div>

                <ng-template *ngIf="!isCameraExist">
                    Camera device not available
                </ng-template>
                <div class="d-flex flex-row justify-content-end mt-3 mx-3 mb-3">
                    <button class="btn btn-cancel mr-2" data-dismiss="modal" (click)="clear()">Cancel</button>
                    <button class="btn btn-theme" (click)="takeSnapshot()">Capture</button>
                </div>
            </div>
        </div>
    </div>
</div>